import React from "react";
import { RadioCheckBox } from "assets/scss/common/controls/inputRadioCheckBox";
import { Icon } from "@nykaa/payment-ui/src/Icon";
import { getIcons, ICONS_NAMES } from "helpers/utils/getIcons";


export const CheckBox = ({ isChecked, borderRadius, dataTestId }: CheckBoxProps) => {
  const platform = __PLATFORM__;

  return (
    <div className="check">
      <RadioCheckBox className="select" borderRadius={borderRadius} dataTestId={dataTestId}>
        <label
          className="control control--checkbox"
        >
          <input
            type="checkbox"
            data-testid={dataTestId}
            className={isChecked ? "checked" : ""}
          />
          <div className="control__indicator-icon">
            <Icon icon={getIcons(platform, isChecked ? ICONS_NAMES.RADIO_ACTIVE : ICONS_NAMES.RADIO)} />
          </div>
          <div className="control__indicator" />
        </label>
      </RadioCheckBox>
    </div>
  );
};
